/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MashtabTariff } from './MashtabTariff';
import type { TypeOfPersonality } from './TypeOfPersonality';
export type UserAdd = {
    firstName?: string;
    lastName?: string;
    email?: string;
    password?: string;
    country?: string;
    city?: string;
    description?: string;
    is_married?: string;
    role?: UserAdd.role;
    tg_id?: number;
    tg_avatar?: string;
    tg_username?: string;
    tg_raw?: Record<string, any>;
    sex?: string;
    birthday_day?: string;
    type_of_personality?: TypeOfPersonality;
    is_onboarding_done?: boolean;
    onboarding_step?: number;
    occupation?: string;
    /**
     * Instagram profile URL
     */
    instagram?: string;
    /**
     * Telegram channel URL
     */
    telegram_channel?: string;
    mashtab_tariff?: MashtabTariff;
    is_doooom?: boolean;
};
export namespace UserAdd {
    export enum role {
        ROOT = 'root',
        ADMIN = 'admin',
        FOCUS_GROUP = 'focus_group',
        USER = 'user',
    }
}

